export const InputStyles = {
    passcode: {
        wrapper: "flex justify-center gap-x-2 min-w-fit",
        container: "mb-2",
        label: "text-sm text-left font-medium text-iw-textSecondary",
        inputRow: "flex items-center gap-2 sm:gap-3.5",
        inputGroup: "flex items-stretch gap-2 sm:gap-3.5 py-2 rounded-lg",
        input: "pin-input-box-style",
        inputFocus: "pin-input-focus-box-border",
        inputBlur: "pin-input-box-border",
        toggleGroup: "flex items-center gap-4 py-2 rounded-lg",
        toggleButton: "pin-input-box-border pin-input-box-style flex items-center justify-center focus:outline-none",
        eyeIcon: "text-iw-grayLight"
    }
}